import { CdkTreeNode } from '@angular/cdk/tree';
import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AppService } from '@app/app.service';
import { TreeComponentClass } from '@app/core/libraries/Tree/core/classes/treeComponent.class';
import { InputSearchComponent } from '@components/input-search/component/input-search.component';
import { TreeService } from '../../services/tree.service';

@Component({
    selector: 'tree-common',
    templateUrl: './tree-common.component.html',
    styleUrls: ['../../styles/treeStyle.scss'],
    providers: [TreeService],
})
export class TreeCommonComponent extends TreeComponentClass implements OnInit {
    /** Список узлов во вьюшке */
    @ViewChildren('treeNode') declare nodesList: QueryList<CdkTreeNode<any>>;
    @ViewChildren('treeNodeRef') declare nodesRefList: QueryList<ElementRef>;
    @ViewChild('treeContainer') declare treeContainer: ElementRef;
    @ViewChild(InputSearchComponent) declare searchRowRef: InputSearchComponent;

    /**
     * Конструктор класса
     * @param appService - глобальный сервис приложения
     * @param service - сервис дерева
     */
    constructor(
        public appService: AppService,
        public service: TreeService,
    ) {
        super(service);
    }
}
